import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PortfolioItemModel} from '../../assets/data/portfolio-item.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-case-dialog',
  templateUrl: './case-dialog.component.html',
  styleUrls: ['./case-dialog.component.scss']
})
export class CaseDialogComponent implements OnInit {

  videoSafeLink: SafeResourceUrl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: PortfolioItemModel, private sanitizer: DomSanitizer) {
    this.videoSafeLink = this.sanitizer.bypassSecurityTrustResourceUrl(data.video + "?autoplay=1");
  }

  ngOnInit(): void {
  }

}
